import { useList } from '@refinedev/core'
import type { Subject } from '@/types'

/** Subject picker source, shared by the content form, plans and notifications. */
export function useSubjectOptions() {
  const { data, isLoading } = useList<Subject>({
    resource: 'subjects',
    pagination: { mode: 'off' },
    sorters: [{ field: 'sort_order', order: 'asc' }],
  })
  return { subjects: data?.data ?? [], isLoading }
}
